import Vue from 'vue'
import Vuex from 'vuex'

import { alert } from './alert.module'
import { authentication } from './authentication.module'
import { users } from './users.module'
import { customers } from './customers.module'
import { devices } from './devices.module'
import { drivers } from './drivers.module'
import { tours } from './tours.module'
import { contracts } from './contracts.module'
import { locations } from './location.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    alert,
    authentication,
    users,
    customers,
    devices,
    drivers,
    tours,
    contracts,
    locations
  }
})
